export default "__VITE_ASSET__JFTbajuD__"